import { twMerge } from 'tailwind-merge'
import classNames from 'classnames'

export default (...args: classNames.ArgumentArray) => twMerge(classNames(args))
